// extracted by mini-css-extract-plugin
export default {"prevIcon":"NavigationArrows__prevIcon___OjK5d","nextIcon":"NavigationArrows__nextIcon___nZyb5","angleIcon":"NavigationArrows__angleIcon___w8cWX"};